import { NormalizedNumber, UnixTimestamp } from '@sparkdotfi/common-universal'

import { TransferFromUserFormNormalizedData } from '@/features/dialogs/common/logic/transfer-from-user/form'

export interface CreateTxOverviewParams {
  amountStaked: NormalizedNumber
  nextEpochEnd: UnixTimestamp
  formValues: TransferFromUserFormNormalizedData
}

export type TxOverview =
  | { status: 'no-overview' }
  | {
      status: 'success'
      claimableOn: Date
    }

export function createTxOverview({ formValues, nextEpochEnd }: CreateTxOverviewParams): TxOverview {
  const amount = formValues.value
  if (amount.eq(0)) {
    return { status: 'no-overview' }
  }

  return {
    status: 'success',
    claimableOn: nextEpochEnd.toDate(),
  }
}
